/**
 * AureNovel 品牌 - Member 页面配置
 */
import novelarcVipIcon from '../icons/novelarc/vip.png'
import { memberCommonConfig } from './common'
import type { MemberPageConfig } from './types'

/**
 * AureNovel 品牌特定主题配置
 */
export const theme = {
  // 头像边框色
  avatarBorder: '#FFF8E8',
  // 按钮背景色
  btnPrimaryBg: '#FFF8E8',
  // Top Up 按钮背景色
  topUpBtnBg: 'linear-gradient(90deg, #FFD666 0%, #FFB300 100%)',
  // VIP 背景图 URL
  vipSubscribeBg: 'url(/images/aurenovel/member_subscribe_bg.webp)',
} as const

/**
 * AureNovel 品牌特定资源配置
 */
export const resources = {
  // 页面背景图
  memberBg: '/images/aurenovel/member-bg.webp',
  // 用户背景图
  userBg: '/images/aurenovel/member-bg.webp',
  // 用户默认头像
  userDefaultAvatar: '/images/aurenovel/user-default.png',
  // VIP 图标
  memberVip: novelarcVipIcon,
  // VIP 折扣图标
  memberVipDiscount: '/images/aurenovel/vip-icon.png',
} as const

/**
 * AureNovel 品牌菜单图标（金色统一风格）
 */
export const menuIcons = {
  transaction: '/images/aurenovel/member/icon-transaction.png',
  unlocked: '/images/aurenovel/member/icon-unlock.png',
  contactUs: '/images/aurenovel/member/icon-contact.png',
  setting: '/images/aurenovel/member/icon-setting.png',
} as const

export const memberConfig: MemberPageConfig = {
  theme,
  resources,
  texts: memberCommonConfig.texts,
  menuIcons,
}
